/**
 * @format
 * @flow
 */
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import DateJp from '../../../../node_modules/UltraDate.js/UltraDate';
import { Link } from 'react-router-dom';
import {
  getInvoiceInfo,
  resetInvoiceInfo,
  setInvoiceStatus,
  modalCloseInTask
} from '../../../actions/Task';
import generateCalendarHash from '../../../lib/generate_calendar_hash';
import Template from '../../../components/Template/AfterLoginTemplate';
import { getSetting } from '../../../actions/Setting';
import * as RT from '../../../constants/Routing';
import IModal from '../../../components/Common/InvoiceModal';
import Moment from 'moment';
import { Collapse } from 'react-collapse';
import Modal from '../../../components/Common/Modal';
var Highlight = require('react-highlighter');

DateJp.setDefaultLocale('ja');

class Component extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedDate: new DateJp().format('yyyy/MM'),
      isOpen: false,
      isCollapse: []
    };
    this.currentUser = JSON.parse(localStorage.getItem('current_user'));
    this.items = [];
  }

  componentWillReceiveProps = next => {
    console.log('TCL: Component -> next', next);
    if (this.items !== next.Task.invoiceInfo.invoices) {
      this.items = next.Task.invoiceInfo.invoices;
      this.setState({});
    }
  };

  componentWillMount = () => {
    const token = this.currentUser.accessToken;
    const { enterpriseId } = this.currentUser;
    this.props.getInvoiceInfo(token, enterpriseId);
    this.props.getSetting(enterpriseId, token, this.currentUser.email);
  };
  // format('YYYY年MM月DD日 hh時mm分')
  componentWillUnmount = () => {
    this.props.resetInvoiceInfo();
  };

  _renderPaymentItems = () => {
    if (this.items.length === 0) {
      const items = this.props.Task.invoiceInfo.invoices;
      this.items = items;
      console.log('TCL: Component -> _renderPaymentItems -> this.items', items);
    }
    if (this.items !== null && this.items != undefined) {
      if (this.items.length > 0) {
        return this.items.map((item, index) => {
          let momentObj = Moment(item.monthName, 'YYYY/MM');
          const dateFrom = Moment(item.deadLine).format('YYYY年MM月DD日');
          const bufferDate = Moment(item.bufferDate).format('YYYY-MM-DD');
          const currentDate = Moment().format('YYYY-MM-DD');
          let yearA = momentObj.year();
          let monthA = momentObj.month() + 1;

          let color =
            item.invoiceStatus === '1'
              ? '#4BA7A1'
              : item.invoiceStatus === '2'
              ? '#A48422'
              : item.invoiceStatus === '3'
              ? '#5E8D4A'
              : item.invoiceStatus === '4'
              ? '#59a758'
              : item.invoiceStatus === '5'
              ? '#d6494b'
              : '';
          let backgroundColor =
            item.invoiceStatus === '1'
              ? '#ADD3D1'
              : item.invoiceStatus === '2'
              ? '#D2C7A0'
              : item.invoiceStatus === '3'
              ? '#9ED884'
              : item.invoiceStatus === '4'
              ? '#edffe6'
              : item.invoiceStatus === '5'
              ? '#ffeced'
              : '';
          return (
            <tr className={index % 2 == 0 ? '' : 'invoice-table-row'}>
              <td>{item.invoiceId}</td>
              <td>
                {yearA}年 {monthA}月分
              </td>
              <td>
                {String(item.amount).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')}円
                <Link
                  to={RT.PAYMENT_SHOW_PATH.replace(/:year/, yearA.toString()).replace(
                    /:month/,
                    monthA.toString().length === 1 ? '0' + monthA.toString() : monthA.toString()
                  )}
                >
                  {' '}
                  明細
                </Link>
              </td>
              <td>{dateFrom}</td>
              <td>
                <Highlight
                  search={item.statusJP}
                  matchStyle={{ color: color, backgroundColor: backgroundColor }}
                >
                  {item.statusJP}
                </Highlight>
                {currentDate > bufferDate && item.invoiceStatus === '2' && (
                  <div>
                    <button
                      type=""
                      className=""
                      onClick={() => {
                        this.expandView(index, item.isCollapse);
                      }}
                    >
                      🔻
                    </button>
                    <div>
                      <Collapse isOpened={item.isCollapse}>
                        <button
                          type=""
                          className=""
                          onClick={() => {
                            this.changeStatus(item.monthName, item.invoiceId, '3');
                          }}
                        >
                          <Highlight
                            search={'支払い通知'}
                            matchStyle={{ color: '#757676', backgroundColor: '#FDFFF5' }}
                          >
                            {'支払い通知'}
                          </Highlight>
                        </button>
                        <button
                          type=""
                          className=""
                          onClick={() => {
                            alert('info');
                          }}
                        >
                          ℹ️
                        </button>
                      </Collapse>
                    </div>
                  </div>
                )}
              </td>
              <td>
                {currentDate > bufferDate && (
                  <Link
                    to={RT.PAYMENT_PDF_PATH.replace(/:invoiceId/, item.invoiceId)
                      .replace(/:year/, yearA.toString())
                      .replace(
                        /:month/,
                        monthA.toString().length === 1 ? '0' + monthA.toString() : monthA.toString()
                      )
                      .replace(/:dueDate/, item.deadLine)}
                  >
                    PDF
                  </Link>
                )}
              </td>
            </tr>
          );
        });
      } else {
        return (
          <tr>
            <td colSpan="6">請求対象となる実施済みのタスクがありません。</td>
          </tr>
        );
      }
    } else {
      return (
        <tr>
          <td colSpan="6">請求対象となる実施済みのタスクがありません。</td>
        </tr>
      );
    }
  };

  expandView = (index, isCollapse) => {
    this.items[index].isCollapse = !isCollapse;
    this.setState({});
  };

  changeStatus = (monthName, invoiceId, status) => {
    const token = this.currentUser.accessToken;
    const { enterpriseId } = this.currentUser;
    this.props.setInvoiceStatus(token, {
      enterpriseId,
      monthName,
      invoiceId,
      status,
      updateDate: new DateJp().format('yyyy/MM/dd HH:mm:ss')
    });
  };

  render = () => {
    const { totalRewal } = this.props.Task.paymentInfo;
    console.log('TCL: render -> this.props', this.props);
    const { feeRate } = this.props.Setting.currentSetting;
    const strRate = feeRate != undefined ? feeRate : '0';
    return (
      <Template>
        <IModal
          isOpen={this.state.isOpen}
          closeModal={() => this.setState({ isOpen: false })}
          headerTitle="お問い合わせ"
          okClickHandler={null}
        />
        <Modal
          isOpen={this.props.App.modalOpen}
          closeModal={this.props.modalCloseInAuth}
          headerTitle={this.props.App.modalHeader}
          okClickHandler={() => this.props.modalCloseInTask()}
          okText="閉じる"
          okBtnClass="btn btn-primary"
        >
          {this.props.App.modalText}
        </Modal>
        <div className="invoice-block">
          <h2>支払状況について</h2>
          <div className="row">
            <div className="col-10 invoice-table-title">
              <h3 className="sub-title">
                いつもtaskellをご利用くださいまして、誠にありがとうございます。ご利用料金やお支払いの状況を表示します。
                <br />
                詳細は『明細』をクリックしてご確認ください。ご利用料金の確定後に請求書（PDF）をダウンロードすることができます。
              </h3>
            </div>
            <div className="col-2 invoice-table-title">
              <h6> ご利用手数料：{strRate}%</h6>
              <h6>
                {' '}
                お支払い先は<Link onClick={() => this.setState({ isOpen: true })}>こちら</Link>
              </h6>
            </div>
          </div>
          <div className="invoice-table table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>請求ID</th>
                  <th>ご請求月</th>
                  <th>金額（税込）</th>
                  <th>お支払い期限</th>
                  <th>ステータス</th>
                  <th> ご請求PDF</th>
                </tr>
              </thead>
              <tbody>{this._renderPaymentItems()}</tbody>
            </table>
          </div>
        </div>
      </Template>
    );
  };
}

const mapStateToProps = state => state;
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    { getInvoiceInfo, resetInvoiceInfo, setInvoiceStatus, modalCloseInTask, getSetting },
    dispatch
  );

const Container = connect(mapStateToProps, mapDispatchToProps)(Component);

export default withRouter(Container);
